import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=50e780db&t=1"
import script from "./Table.vue?vue&type=script&lang=js&t=1"
export * from "./Table.vue?vue&type=script&lang=js&t=1"
import style0 from "./Table.vue?vue&type=style&index=0&id=50e780db&prod&lang=scss&t=1"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports